<div class="modal-header">
    <h4 class="modal-title">Edit {{isCashnet ? 'Location' : 'Merchant'}} ID</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body">
    <form [formGroup]="setMerchantIdForm" novalidate>
        <div class="mb-3 row">
            <label for="merchantId" class="col-3 col-form-label text-end">{{isCashnet ? 'Location' : 'Merchant'}} ID</label>
            <div class="col">
                <input type="text" class="form-control" id="merchantId" formControlName="merchantId" [ngClass]="{ 'is-invalid': merchantId.errors && showErrors }" [maxlength]="maxlength">
                <small id="merchantIdHelp" class="form-text">Max of {{isCashnet ? '10' : '25'}} characters.</small>
                <div *ngIf="merchantId.invalid && showErrors" class="text-danger">
                    <small *ngIf="merchantId.errors.required">{{isCashnet ? 'Location' : 'Merchant'}} ID is required</small>
                    <small *ngIf="merchantId.errors.notUnique">{{isCashnet ? 'Location' : 'Merchant'}} ID must be unique</small>
                </div>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="submit" class="btn btn-primary" (click)="onSave()" [disabled]="saving">
        <i class="fa fa-save"></i> Save <action-spinner *ngIf="saving"></action-spinner>
    </button>
</div>
